﻿module.exports = {

    start: function (button) {

        button.classList.add('button--loading', 'button--disabled');
        button.setAttribute('button--disabled', 'button--disabled');

    },

    reset: function (button) {

      button.classList.remove('button--loading', 'button--disabled', 'button--success');
      button.removeAttribute('button--disabled');

    },

    success: function (button) {

        button.classList.remove('button--loading', 'button--disabled');
        button.classList.add('button--success');

        button.removeAttribute('button--disabled');

        setTimeout(function () {
            button.classList.remove('button--success');
        }, 1500);
    }
};
